import React from 'react';

import { NavLink } from 'react-router-dom';

import { Model } from 'types';
import { Column } from 'ffsdk';

export const columns: Column<Model>[] = [
  {
    content: 'Nosaukums',
    key: 'title',
    render: ({ id, title }) => <NavLink to={`/transport/models/${id}`}>{title}</NavLink>,
  },
  {
    content: 'Ražotājs',
    key: 'brand',
  },
  {
    content: 'Tips',
    key: 'type',
  },
];
